define(function () {
  "use strict";

  return /<([a-z][^\/\0>\x20\t\r\n\f]+)/i;
});